import { UserControllerService } from 'shared/api/generatedApi/services/UserControllerService';
import { UpdateUserStatusRequestDto, UserRequestDto, UserResponseDto } from 'shared/api';

export const userApi = {
  getUserById: (id: number) => UserControllerService.findUserById(id),
  findUserByKeycloakUserId: (keycloakUserId: string) => UserControllerService.findUserByKeycloakUserId(keycloakUserId),
  updateUser: (id: number, data: UserRequestDto) => UserControllerService.updateUser(id, data),
  updateUserStatus: (id: number, status: UpdateUserStatusRequestDto.status) => UserControllerService.updateUserStatus(
    id,
    { status },
  ),
  deleteUser: (id: number) => UserControllerService.deleteUser(id),
  getUsers: (email?: string, status?: UserResponseDto.status, company?: string) => UserControllerService.findUsers(
    email,
    status,
    company,
  ),
  createUser: (data: UserRequestDto) => UserControllerService.createUser(data),
};
